import React, { useEffect, useState } from "react";
import { useLazyApplicationPaymentsQuery } from "../../service/applications";
import { errorToast } from "../../helpers";

import {
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import { PAYMENT_STATUS_LABELS } from "../../utils/enums";
import { PaymentResponse } from "../../types/General";
import moment from "moment";
import { PriceFormatter } from "../../utils/commoFunctions";

type props = {
  id: string | undefined;
};
const ApplicationPayments = ({ id }: props) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<PaymentResponse[]>([]);
  const [payments] = useLazyApplicationPaymentsQuery();

  const getPaymentDetails = async (id: number) => {
    setLoading(true);

    try {
      const response = await payments({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setDetail(response?.data);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getPaymentDetails(Number(id));
    }
  }, []);

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        Payment History
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : detail?.length ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Payment Name</TableCell>
                <TableCell>Amount Paid</TableCell>
                <TableCell>VAT</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detail?.map((payment, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {PAYMENT_STATUS_LABELS[payment?.payment_status] ||
                      "Unknown"}
                  </TableCell>
                  <TableCell>
                    {PriceFormatter(
                      payment?.payment_amt_after_vat?.toString()
                    ) || ""}
                  </TableCell>
                  <TableCell>
                    {PriceFormatter(payment?.vat?.toString()) || ""}
                  </TableCell>
                  <TableCell>
                    {payment?.created_at
                      ? moment(payment?.created_at).format("DD MMM YYYY")
                      : "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography>No payment history found.</Typography>
      )}
    </Box>
  );
};

export default ApplicationPayments;
